import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import OutlinedButton from "../../../components/button/OutlinedButton";
import H1 from "../../../components/typography/H1";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  position: relative;
  height: 100px;
  width: 100%;
  overflow: hidden;
`;

const Overlay = styled.div`
  width: 100%;
  background-color: ${colors.black};
  inset: 0;
  height: 100%;
  /* padding: 0px 20px; */
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.9) 100%
  );
`;

const Inner = styled.div`
  z-index: 1;
  width: fit-content;
  height: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  gap: 60px;
  text-align: center;
  color: ${colors.backgroundPrimary};
  p {
    color: #cac7c7;
    font-size: ${fontSize.m};
  }
  @media (max-width: 800px) {
    gap: 20px;
    h1 {
      font-size: ${fontSize.l};
    }
    p {
      font-size: ${fontSize.s};
    }
  }
  @media (max-width: 500px) {
    gap: 10px;
    h1 {
      display: none;
    }
    p {
      font-size: ${fontSize.xs};
    }
  }
`;

function SaleBanner() {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <Overlay>
        <Inner>
          <H1>Wallet Sale</H1>
          <p>Don’t miss out — your favorite pieces up to 30% off.</p>
          <OutlinedButton
            text={"Shop Now"}
            onClick={() => {
              navigate("/products/flag/sale");
            }}
          />
        </Inner>
      </Overlay>
    </Wrapper>
  );
}

export default SaleBanner;
